const THUMBNAIL_IMAGE_BASE_URL = 'https://duskbreakers.gg/breaker_thumbnails/';
const FULL_IMAGE_BASE_URL = 'https://duskbreakers.gg/breaker_images/';

export const getThumbnailUrl = (id: number) => {
  return `${THUMBNAIL_IMAGE_BASE_URL}${id}.jpg`;
};

export const getFullImageUrl = (id: number) => {
  return `${FULL_IMAGE_BASE_URL}${id}.png`;
};
